import { render, staticRenderFns } from "./BookingReport.vue?vue&type=template&id=35b7be5a&scoped=true&"
import script from "./BookingReport.vue?vue&type=script&lang=js&"
export * from "./BookingReport.vue?vue&type=script&lang=js&"
import style0 from "./BookingReport.vue?vue&type=style&index=0&id=35b7be5a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35b7be5a",
  null
  
)

export default component.exports